module.exports = __webpack_public_path__ + "915deaa1d7bcaf463cda7b1d9748bb3b.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/foundation.jpg
 ** module id = 441
 ** module chunks = 0
 **/